import { render } from "./PrList.vue?vue&type=template&id=29add2ca&scoped=true"
import script from "./PrList.vue?vue&type=script&lang=js"
export * from "./PrList.vue?vue&type=script&lang=js"

import "./PrList.vue?vue&type=style&index=0&id=29add2ca&scoped=true&lang=css"
import "./PrList.vue?vue&type=style&index=1&id=29add2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29add2ca"]])

export default __exports__